/**============================================================
*   [qaToggle]
*   description : よくある質問のトグル
============================================================*/
// すべての質問要素を取得
let questions = document.querySelectorAll('.p-ohakaerabi-q');

questions.forEach(question => {
    question.addEventListener('click', function() {
        let answer = this.nextElementSibling;

        // "open"クラスがあるかチェックして、追加/削除を切り替える
        if (answer.classList.contains('open')) {
            question.classList.remove('open');
            answer.classList.remove('open');
        } else {
            question.classList.add('open');
            answer.classList.add('open');
        }
    });
});
